import mtz from 'moment-timezone'
import { createSlice } from '@reduxjs/toolkit'
import { getTimezones } from '../lib/api'

export const timezoneSlice = createSlice({
  name: 'timezone',
  initialState: {
    current: mtz.tz.guess(),
    timezones: [],
    loaded: false,
    loading: false,
    error: null
  },

  reducers: {
    loading: state => {
      state.loading = true
    },
    load: (state, { payload }) => {
      state.timezones = payload
      state.loaded = true
      state.loading = false
    },
    failed: (state, { payload }) => {
      state.error = payload
      state.loading = false
      state.loaded = true
    }
  }
})

export default timezoneSlice.reducer

export const { loading, load, failed } = timezoneSlice.actions

// Asynchronous thunk action
export function fetchTimezones () {
  return async dispatch => {
    dispatch(loading())
    try {
      const timezones = await getTimezones()
      dispatch(load(timezones))
    } catch (error) {
      console.error('Fetch error in TimezoneSlice')
      dispatch(failed(error))
    }
  }
}

export const selectTimezone = state => state.timezone
